import { render, staticRenderFns } from "./UserDashboardPage.vue?vue&type=template&id=94ef177a&"
import script from "./UserDashboardPage.vue?vue&type=script&lang=ts&"
export * from "./UserDashboardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports